export const SUB_ACCOUNT_PERMISSION_KEYS = [
  'can_chat',
  'can_edit_ai',
  'can_manage_sub_accounts',
  'can_view_stats',
  'can_access_uncove_iframe',
  'can_use_mass_dm',
  'can_manage_uncove_profile',
  'can_manage_all_permissions',
];

export const hasGlobalSubAccountPermission = (permissions) => (
  permissions?.can_manage_all_permissions === true
);

export const hasSubAccountPermission = (permissions, permission, isAdmin = false) => Boolean(
  isAdmin ||
  permissions?.[permission] === true ||
  hasGlobalSubAccountPermission(permissions)
);

export const canAccessSubAccountFeature = (details, permission, isAdmin = false) => (
  details?.is_sub_account !== true ||
  hasSubAccountPermission(details?.sub_account_permissions, permission, isAdmin)
);
